var styles = {"md":"nv-markdown--md"};

export { styles as default };
//# sourceMappingURL=NvMarkdown.module.esm.js.map
